import React from 'react';
import PropTypes from 'prop-types';
import './Packages.css';
import Package from '../Package/Package';
import { SalesContext } from 'src/Context/SalesContext';
import { getPageArray } from 'src/Utility/utility';

class Packages extends React.Component {
  static contextType = SalesContext;

  clearFilters() {

    this.context.setFilterList([]);
    this.context.setSelectedPageNo(1);
    this.context.setPageNos(getPageArray([this.context?.providerPackages]), () => this.props.determinePackages());
  }

  render() {
  
    let packages = this.props?.packages;
    let showNoPackages = false;

    if (!packages || packages?.length < 1) {

      showNoPackages = true;
    };

    let recommededPackages = [];

    for (let i = 0; i < packages?.length; i++) {

      if (!!packages[i].isRecommended) {
        
        recommededPackages.push(packages[i]);
      };
    };
  
    return (
      <React.Fragment>
        { !this.context.showSpinner
          ? !showNoPackages
            ? <div>

                { recommededPackages && recommededPackages.length > 0 &&
                  <>
                    <div className="recommeded-packages-badge">Recommended for you</div>
                    <div className="packages-section-container recommeded-packages-section-container">
                      { recommededPackages?.map((item, index) => {
                          return (
                            <div key={index} className="package-component">
                              <Package item={item} automationidattr={index} />
                            </div>
                          )
                        })
                      }
                    </div>
                  </>
                }

                <div className="packages-section-container">
                
                  { Array.isArray(packages)
                    ? packages?.map((item, index) => {
                        if (!item.isRecommended) {
                          return (
                            <div key={index} className="package-component">
                              <Package item={item} automationidattr={index} />
                            </div>
                          )
                        }
                      })
                    : null
                  }
                </div>

            </div>
            : <div className="packages-no-packages-wrapper">
                
                We're sorry, but there are no results that match your search.
                
                <div>
                  <button className="packages-clear-filter-button" onClick={() => {this.clearFilters()}}>
                    Clear search
                  </button>
                </div>

              </div>
          : null
        }

      </React.Fragment>
    )
  }
}

Packages.propTypes = {
  determinePackages: PropTypes.func,
  packages: PropTypes.array
};

export default (Packages);